import { render, staticRenderFns } from "./passRuleList.vue?vue&type=template&id=4fd02370&scoped=true"
import script from "./passRuleList.vue?vue&type=script&lang=js"
export * from "./passRuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd02370",
  null
  
)

export default component.exports